import { configureStore } from '@reduxjs/toolkit'
import sidebar from './slice'
import authReducer from './slices/authSlice'

export const store = configureStore({
  reducer: {
    sidebar,
    auth: authReducer,
  },
})
